import { useEffect, useState } from 'react'

type SearchBanners = {
  area: string
  html: string
  id: string
  name: string
}

interface Props {
  searchBanners?: {
    banners: SearchBanners[]
  }
  area: string
}

const SearchBannersComponent = ({ searchBanners, area }: Props) => {
  const [areaOneMobileBanner, setAreaOneMobileBanner] = useState<any>([])
  const [areaOneDesktopBanner, setAreaOneDesktopBanner] = useState<any>([])
  const [areaTwoMobileBanner, setAreaTwoMobileBanner] = useState<any>([])
  const [areaTwoDesktopBanner, setAreaTwoDesktopBanner] = useState<any>([])

  useEffect(() => {
    setAreaOneMobileBanner([])
    setAreaOneDesktopBanner([])
    setAreaTwoMobileBanner([])
    setAreaTwoDesktopBanner([])

    if (!searchBanners) {
      return
    }

    const { banners } = searchBanners

    const bannerOne = banners.filter((banner) => {
      return banner.area === 'one'
    })

    setAreaOneMobileBanner(
      bannerOne.filter((e) => {
        return e.name.includes('mobile')
      })
    )

    setAreaOneDesktopBanner(
      bannerOne.filter((e) => {
        return e.name.includes('desktop')
      })
    )

    const bannerTwo = banners.filter((banner) => {
      return banner.area === 'two'
    })

    setAreaTwoMobileBanner(
      bannerTwo.filter((e) => {
        return e.name.includes('mobile')
      })
    )

    setAreaTwoDesktopBanner(
      bannerTwo.filter((e) => {
        return e.name.includes('desktop')
      })
    )
  }, [searchBanners])

  return (
    <>
      {areaOneMobileBanner?.length > 0 && area === 'one' && (
        <div
          data-banner-area-one-mobile
          dangerouslySetInnerHTML={{
            __html: areaOneMobileBanner[0].html,
          }}
        />
      )}
      {areaOneDesktopBanner?.length > 0 && area === 'one' && (
        <div
          data-banner-area-one-desktop
          dangerouslySetInnerHTML={{
            __html: areaOneDesktopBanner[0].html,
          }}
        />
      )}

      {areaTwoMobileBanner?.length > 0 && area === 'two' && (
        <div
          data-banner-area-two-mobile
          dangerouslySetInnerHTML={{
            __html: areaTwoMobileBanner[0].html,
          }}
        />
      )}
      {areaTwoDesktopBanner?.length > 0 && area === 'two' && (
        <div
          data-banner-area-two-desktop
          dangerouslySetInnerHTML={{
            __html: areaTwoDesktopBanner[0].html,
          }}
        />
      )}
    </>
  )
}

export default SearchBannersComponent
